export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyZSUyMGFic3RyYWN0fGVufDB8fHx8MTc4NDQzNjExMQ&ixlib=rb-4.1.0&q=85",
  field: "https://images.unsplash.com/photo-1464226184884-fa280b87c399?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxncmFpbnMlMjBmaWVsZHxlbnwwfHx8MTc4NDQzNjMyNA&ixlib=rb-4.1.0&q=85",
  port: "https://images.unsplash.com/photo-1527314392553-2c7bded21b23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxwb3J0JTIwY29udGFpbmVycyUyMGxvZ2lzdGljcyUyMHN1bnNldHxlbnwwfHx8fDE3ODM2ODY1NTd8MA&ixlib=rb-4.1.0&q=85",
  containers: "https://images.unsplash.com/photo-1605732562084-f528a2154616?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxwb3J0JTIwY29udGFpbmVycyUyMGxvZ2lzdGljcyUyMHN1bnNldHxlbnwwfHx8fDE3ODM2ODY1NTd8MA&ixlib=rb-4.1.0&q=85",
  dryFruitsWide: "https://images.pexels.com/photos/37270167/pexels-photo-37270167.jpeg",
  dryFruitsJar: "/images/packed-jar.jpg",
};

export const STATS = [
  { value: 93, suffix: "+", label: "Export Countries", sub: "Trusted partnerships worldwide" },
  { value: 4000, suffix: "+", label: "Farm Partners", sub: "Strong farmer network across India" },
  { value: 6, suffix: "", label: "Commodity Portfolios", sub: "Staples to specialty" },
  { value: 100, suffix: "%", label: "Quality Focus", sub: "Multi-stage inspection" },
];

export const VALUES = ["INTEGRITY", "EXCELLENCE", "INNOVATION", "COLLABORATION", "GLOBAL IMPACT"];

export const PRODUCTS = [
  {
    slug: "dry-fruits-nuts",
    name: "Dry Fruits & Nuts",
    tagline: "Natural Goodness. Premium Quality. Global Choice.",
    image: "/images/dryfruits.jpg",
    flagship: true,
    brand: "DryVeda",
    desc: "Carefully sourced from premium orchards and farms across the world — each harvest selected for superior taste, nutrition and freshness. Processed and packed at our New Delhi unit under our DryVeda brand, with stringent quality checks and hygienic conditions.",
    varieties: ["Almonds", "Cashews", "Pistachios", "Walnuts", "Raisins", "Dates", "Mixed Nuts"],
    applications: ["Retail", "Health & Nutrition", "Bakery & Confectionery", "Premium Gifting", "Hotels & Restaurants", "Export Markets"],
  },
  {
    slug: "rice",
    name: "Rice",
    tagline: "Naturally nurtured. Expertly sourced. Globally trusted.",
    image: "/images/rice.jpg",
    desc: "From premium basmati to everyday staples — consistent quality, unmatched taste and reliable supply from the finest growing regions of India.",
    varieties: ["Basmati Rice", "Non-Basmati Rice", "White Rice", "Brown Rice", "Steam Rice", "Parboiled Rice"],
    applications: ["Retail", "Food Service", "Hospitality", "Food Processing", "Institutional Supply", "Export Trade"],
  },
  {
    slug: "spices",
    name: "Spices",
    tagline: "Bold flavors. Pure origin. Global standards.",
    image: "/images/spices.jpg",
    desc: "Selected from India's most renowned growing regions for aroma, color, purity and essential oils — food-safety assured from farm to final packaging.",
    varieties: ["Chili", "Black Pepper", "Cardamom", "Turmeric", "Cumin", "Coriander", "Cinnamon", "Clove"],
    applications: ["Retail", "Food Service", "Hospitality", "Ayurveda & Wellness", "Export Trade"],
  },
  {
    slug: "oilseeds",
    name: "Oilseeds",
    tagline: "Naturally rich. Globally sourced. Consistently delivered.",
    image: "/images/oilseeds.jpg",
    desc: "Superior yield, rich oil content and trusted quality for food, industrial and animal-nutrition industries worldwide.",
    varieties: ["Soyabean", "Rapeseed / Canola", "Sunflower Seed", "Sesame Seed", "Groundnut", "Cottonseed", "Palm Kernel"],
    applications: ["Edible Oils", "Food Processing", "Oleochemicals", "Animal Feed", "Biofuels"],
  },
  {
    slug: "millets-super-grains",
    name: "Millets & Super Grains",
    tagline: "Nourishing today. Sustainable tomorrow.",
    image: "/images/millets.jpg",
    desc: "Nutrient-rich, gluten-free ancient grains, sustainably grown — supporting well-being, food security and the future of responsible sourcing.",
    varieties: ["Pearl Millet (Bajra)", "Finger Millet (Ragi)", "Sorghum (Jowar)", "Little Millet (Samai)", "Kodo Millet", "Quinoa", "Amaranth", "Chia Seeds"],
    applications: ["Retail", "Health & Nutrition", "Baby Food", "Cereals & Snacks", "Export Markets"],
  },
  {
    slug: "foxnuts",
    name: "Foxnuts (Makhana)",
    tagline: "Nature's crunch. Harvested from Indian ponds.",
    image: "/images/foxnuts.jpg",
    brand: "DryVeda",
    desc: "Premium phool makhana from Bihar's pond harvests — popped, graded and packed at our New Delhi unit under our DryVeda brand. Light, protein-rich and gluten-free, loved by health-focused consumers worldwide.",
    varieties: ["Premium Phool Makhana (Suta Grades — 12 & Below)", "Roasted & Salted", "Flavoured — Peri Peri · Cheese · Pudina · Cream & Onion", "Makhana Flour", "Snack Packs & Private Label"],
    applications: ["Retail Snacks", "Health & Wellness", "Fasting & Festive Foods", "Bakery & Sweets", "Private Label", "Export Markets"],
  },
];

export const SUPPLY_CHAIN = [
  { step: "01", title: "Sourcing", desc: "Direct procurement from trusted farmers and producer communities" },
  { step: "02", title: "Aggregation", desc: "Collection, grading and aggregation at strategic locations" },
  { step: "03", title: "Processing", desc: "Advanced processing and cleaning to international quality standards" },
  { step: "04", title: "Quality Assurance", desc: "Multi-stage inspection and laboratory testing for safety and purity" },
  { step: "05", title: "Packaging", desc: "Customised, secure packaging to preserve quality and freshness" },
  { step: "06", title: "Logistics", desc: "Efficient inland transportation to ports and global destinations" },
  { step: "07", title: "Shipping", desc: "Global shipping partnerships for safe, on-time deliveries" },
  { step: "08", title: "Customs & Compliance", desc: "End-to-end documentation and regulatory compliance" },
  { step: "09", title: "Customer Delivery", desc: "Reliable delivery and post-shipment support that builds partnerships" },
];

export const CAPABILITIES = [
  { title: "Global Sourcing Support", desc: "End-to-end export coordination across key markets." },
  { title: "Freight Management", desc: "Optimized freight solutions by sea, air & land." },
  { title: "Customs & Compliance", desc: "Documentation and regulatory clearance support." },
  { title: "Quality Assurance", desc: "Pre-shipment inspection and certification assistance." },
  { title: "Warehousing Solutions", desc: "Secure storage and inventory management support." },
  { title: "Tracking & Visibility", desc: "Real-time updates for complete shipment visibility." },
];

export const TRADE_DOCUMENTS = [
  "Commercial Invoice", "Packing List", "Certificate of Origin", "Bill of Lading / AWB",
  "Phytosanitary Certificate", "Fumigation Certificate", "Insurance Certificate", "Export Licenses (if applicable)",
];

export const INCOTERMS = [
  { code: "EXW", name: "Ex Works", desc: "Buyer arranges pickup from seller's premises." },
  { code: "FOB", name: "Free on Board", desc: "Seller delivers goods on board at the loading port." },
  { code: "CIF", name: "Cost, Insurance & Freight", desc: "Seller covers cost, insurance and freight to destination port." },
  { code: "CFR", name: "Cost & Freight", desc: "Seller covers cost and freight to the destination port." },
  { code: "DAP", name: "Delivered at Place", desc: "Seller delivers goods to the agreed place." },
  { code: "Other", name: "Flexible Terms", desc: "We remain flexible to support mutually agreed arrangements." },
];

export const PACKAGING = [
  { name: "PP Woven Bags", spec: "5kg – 50kg" },
  { name: "Kraft Paper Bags", spec: "1kg – 25kg" },
  { name: "Stand-Up Pouches", spec: "250g – 5kg" },
  { name: "Jars & Containers", spec: "Glass / PET / HDPE" },
  { name: "Tin Cans", spec: "Food Grade" },
  { name: "Corrugated Boxes", spec: "Multi-layer Protection" },
];

export const PACKAGING_FEATURES = [
  "Food-grade & export compliant materials",
  "Moisture, pest & tamper resistant",
  "Custom sizes, printing & labeling",
  "Sustainable & recyclable solutions",
];

export const INDUSTRIES = [
  "Agriculture & Agro Commodities", "Trade & Commodities", "Manufacturing & Industrial",
  "Technology & Digital Systems", "Infrastructure & Construction", "Retail & Consumer Goods",
  "Energy & Utilities", "Government & Public Sector", "Healthcare & Pharmaceuticals", "Education & Institutions",
];

export const MEGA_TRENDS = [
  { title: "Population & Urbanisation", desc: "Global population expected to reach 9.7 billion by 2050, driving strong demand for food." },
  { title: "Changing Consumer Diets", desc: "Shift towards protein, health & convenience across global markets." },
  { title: "Sustainability Mandate", desc: "Global focus on ethical & traceable sourcing for a resilient food ecosystem." },
  { title: "Technology Transformation", desc: "Data, automation and AI driving efficiency across the value chain." },
  { title: "Trade Policy Evolution", desc: "Agricultural trade growing at ~6% CAGR — new policies opening markets & corridors." },
];

export const MANIFESTO = [
  { no: "01", title: "Our Purpose", text: "To connect producers and global markets responsibly, creating value across the agri-food ecosystem." },
  { no: "02", title: "Our Vision", text: "To be a globally trusted partner in agricultural trade, known for integrity, reliability and sustainable growth." },
  { no: "03", title: "Our Promise", text: "Quality you can trust. Supply you can rely on. Partnerships that last." },
  { no: "04", title: "Our Values", text: "Integrity — we do what is right, always. Reliability — consistent supply, trusted delivery. Sustainability — responsible sourcing for a better future. Partnership — growing together, success shared." },
];

export const COUNTRY_CODES = [
  { code: "+91", label: "India" },
  { code: "+971", label: "UAE" },
  { code: "+966", label: "Saudi Arabia" },
  { code: "+974", label: "Qatar" },
  { code: "+968", label: "Oman" },
  { code: "+965", label: "Kuwait" },
  { code: "+973", label: "Bahrain" },
  { code: "+93", label: "Afghanistan" },
  { code: "+61", label: "Australia" },
  { code: "+880", label: "Bangladesh" },
  { code: "+32", label: "Belgium" },
  { code: "+975", label: "Bhutan" },
  { code: "+55", label: "Brazil" },
  { code: "+855", label: "Cambodia" },
  { code: "+1", label: "USA / Canada" },
  { code: "+86", label: "China" },
  { code: "+20", label: "Egypt" },
  { code: "+33", label: "France" },
  { code: "+49", label: "Germany" },
  { code: "+62", label: "Indonesia" },
  { code: "+98", label: "Iran" },
  { code: "+964", label: "Iraq" },
  { code: "+39", label: "Italy" },
  { code: "+81", label: "Japan" },
  { code: "+254", label: "Kenya" },
  { code: "+60", label: "Malaysia" },
  { code: "+960", label: "Maldives" },
  { code: "+52", label: "Mexico" },
  { code: "+212", label: "Morocco" },
  { code: "+95", label: "Myanmar" },
  { code: "+977", label: "Nepal" },
  { code: "+31", label: "Netherlands" },
  { code: "+64", label: "New Zealand" },
  { code: "+234", label: "Nigeria" },
  { code: "+92", label: "Pakistan" },
  { code: "+63", label: "Philippines" },
  { code: "+48", label: "Poland" },
  { code: "+7", label: "Russia" },
  { code: "+65", label: "Singapore" },
  { code: "+27", label: "South Africa" },
  { code: "+82", label: "South Korea" },
  { code: "+34", label: "Spain" },
  { code: "+94", label: "Sri Lanka" },
  { code: "+255", label: "Tanzania" },
  { code: "+66", label: "Thailand" },
  { code: "+90", label: "Turkey" },
  { code: "+44", label: "UK" },
  { code: "+84", label: "Vietnam" },
];

export const CONTACT = {
  email: "info@nishmayy.com",
  address: "New Delhi, India",
  whatsapp: "https://wa.me/919910128137",
};
